import { Pipe, PipeTransform } from '@angular/core';
import { LinkyPipe } from 'angular-linky';

@Pipe({ name: 'linkify' })
export class LinkifyPipe implements PipeTransform {
  transform(value: string, options: any = {}): string {
    options.phone = options.phone || false;
    return new LinkyPipe().transform(value, options);
  }
}
